<div class="watch-layout">

  <!-- Toast notification -->
  <div class="watch-profile-toast" *ngIf="toastMsg" [class.toast-red]="toastColor === 'red'">
    {{ toastMsg }}
  </div>

  <!-- Confirmation dialog -->
  <div class="hide-dialog-backdrop" *ngIf="hideConfirmPost" (click)="cancelHide()">
    <div class="hide-dialog-card" (click)="$event.stopPropagation()">
      <p class="hide-dialog-title">Delete?</p>
      <p class="hide-dialog-body">Delete this from your map and watch feed? This only affects your account.</p>
      <div class="hide-dialog-actions">
        <button class="hide-dialog-btn cancel" type="button" (click)="cancelHide()">Cancel</button>
        <button class="hide-dialog-btn confirm" type="button" (click)="confirmHide()">Hide</button>
      </div>
    </div>
  </div>

  <!-- Main Feed Area -->
  <div class="main-feed">
    <div class="watch-container">
      <!-- Sub-tabs: All · Trips · Waypoints · Photos · Posts (single-select, as in the app) -->
      <div class="watch-filter-tabs" role="tablist" aria-label="Filter feed">
        <button type="button" role="tab" class="watch-filter-tab" [class.active]="activeFilter === null"
          [attr.aria-selected]="activeFilter === null" (click)="selectFilter(null)">All</button>
        <button type="button" role="tab" class="watch-filter-tab" *ngFor="let tab of filterTabs"
          [class.active]="activeFilter === tab.key" [attr.aria-selected]="activeFilter === tab.key"
          (click)="selectFilter(tab.key)">{{ tab.label }}</button>
      </div>

      <div class="feed-list">
        <!-- Skeleton Loaders for initial/pagination loading -->
        <ng-container *ngIf="loading && feed.length === 0">
          <div class="skeleton-card" *ngFor="let i of [1, 2, 3]">
            <div class="skeleton-header">
              <div class="skeleton-avatar"></div>
              <div class="skeleton-text-group">
                <div class="skeleton-line short"></div>
                <div class="skeleton-line x-short"></div>
              </div>
            </div>
            <div class="skeleton-body">
              <div class="skeleton-line long"></div>
              <div class="skeleton-line medium"></div>
              <div class="skeleton-rect"></div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngFor="let post of feed">
          <div #postCard class="feed-item-card" *ngIf="isVisible(post)" [ngClass]="post.post_type" [class.is-post-card]="isTextPost(post)"
            [id]="(post.waypoint_details?.waypoint_id || post.waypoint_details?._id || post.waypoint_details?.id || post.waypoint_ref?.identifier || post.id || post._id) ? 'post-wp-' + (post.waypoint_details?.waypoint_id || post.waypoint_details?._id || post.waypoint_details?.id || post.waypoint_ref?.identifier || post.id || post._id) : ''"
            [class.highlighted]="highlightedPostId && (highlightedPostId === post.waypoint_details?.waypoint_id || highlightedPostId === post.waypoint_details?._id || highlightedPostId === post.waypoint_details?.id || highlightedPostId === post.waypoint_ref?.identifier || highlightedPostId === post.id || highlightedPostId === post._id)">

            <!-- ============================================== -->
            <!-- POST CARD (MATCHES POSTS TAB POST CARD EXACTLY) -->
            <!-- ============================================== -->
            <ng-container *ngIf="isTextPost(post)">
              <div class="wp-user-header">
                <img
                  *ngIf="post.source_profile?.image_url"
                  [src]="post.source_profile?.image_url"
                  class="wp-user-avatar clickable"
                  alt="Author avatar"
                  (click)="onPostAvatarClick(post, $event)"
                  (error)="onImageError($event)"
                />
                <div
                  *ngIf="!post.source_profile?.image_url"
                  class="wp-user-avatar avatar-initials clickable"
                  (click)="onPostAvatarClick(post, $event)"
                >
                  {{ getInitials(getWatchHeaderName(post)) }}
                </div>
                <div class="wp-user-text clickable" (click)="onPostAvatarClick(post, $event)">
                  <span class="wp-user-name">{{ getWatchHeaderName(post) }}</span>
                  <span class="wp-user-time">
                    {{ post.audit_data?.create_ts | relativeTime }}
                  </span>
                </div>

                <div class="privacy-badge" [ngClass]="getBadgeType(post)">
                  <svg *ngIf="getBadgeType(post) === 'public'" viewBox="0 0 24 24" fill="none" width="14" height="14"
                    stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="9"></circle>
                    <path d="M3.6 9h16.8"></path>
                    <path d="M3.6 15h16.8"></path>
                    <path d="M12 3c2.2 2.3 3.4 5.5 3.4 9S14.2 18.7 12 21"></path>
                    <path d="M12 3c-2.2 2.3-3.4 5.5-3.4 9s1.2 6.7 3.4 9"></path>
                  </svg>
                  <svg *ngIf="getBadgeType(post) === 'private'" viewBox="0 0 24 24" fill="none" width="14" height="14"
                    stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="5" y="10" width="14" height="10" rx="2"></rect>
                    <path d="M8 10V7.8C8 5.7 9.8 4 12 4s4 1.7 4 3.8V10"></path>
                    <circle cx="12" cy="15" r="1.2" fill="currentColor" stroke="none"></circle>
                  </svg>
                  <svg *ngIf="getBadgeType(post) === 'custom' || getBadgeType(post) === 'shared'" viewBox="0 0 24 24"
                    fill="none" width="14" height="14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
                    stroke-linejoin="round">
                    <circle cx="9" cy="9" r="2.5"></circle>
                    <circle cx="16.5" cy="8" r="2"></circle>
                    <path d="M5.5 18.5c.6-2.4 2.4-3.8 5-3.8s4.4 1.4 5 3.8"></path>
                    <path d="M15 15.2c1.7.1 2.9 1.1 3.5 3.3"></path>
                  </svg>
                  <span>{{ getBadgeLabel(post) }}</span>
                </div>
              </div>

              <!-- Top divider line below header like all other watch cards -->
              <div class="divider"></div>

              <div class="post-body-wrap">
                <p class="post-text-content" *ngIf="getPostText(post)">
                  {{ getPostText(post) }}
                </p>

                <!-- Attached Images (if any) -->
                <div class="post-media" *ngIf="getPostImages(post).length > 0">
                  <div
                    class="single-image-wrap"
                    *ngIf="getPostImages(post).length === 1"
                    (click)="openPhotoLightbox(post, getPostImages(post)[0], $event)"
                  >
                    <img
                      [src]="getPostImages(post)[0]"
                      alt="Post photo"
                      class="post-photo-single clickable"
                      loading="lazy"
                      (error)="onImageError($event)"
                    />
                  </div>

                  <div
                    class="multi-images-grid"
                    *ngIf="getPostImages(post).length > 1"
                  >
                    <div
                      class="multi-image-item"
                      *ngFor="let img of getPostImages(post) | slice:0:4; let idx = index"
                      (click)="openPhotoLightbox(post, img, $event)"
                    >
                      <img [src]="img" alt="Post photo" class="post-photo-thumb clickable" loading="lazy" (error)="onImageError($event)" />
                      <div class="more-images-overlay" *ngIf="idx === 3 && getPostImages(post).length > 4">
                        +{{ getPostImages(post).length - 4 }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Bottom divider line above interaction bar like all other watch cards -->
              <div class="divider interaction-divider"></div>

              <app-post-interaction-bar
                [postId]="getInteractionPostId(post)"
                [postType]="getInteractionPostType(post)"
                [initialReactions]="post.reactions"
                [initialCommentsCount]="getInteractionCommentsCount(post)"
                [enableShare]="true"
                [compactCommentsSingleButton]="true"
              >
                <button
                  class="card-icon-btn edit-btn"
                  type="button"
                  *ngIf="canEditWatchPost(post)"
                  (click)="openWaypointDetails(post)"
                  title="Edit Post"
                  aria-label="Edit Post"
                >
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                </button>
              </app-post-interaction-bar>
            </ng-container>

            <!-- HEADER: Shared (community) Header — trips & waypoints shared to a fleet -->
            <div class="card-header shared-community-header" *ngIf="!isTextPost(post) && isSharedCommunityPost(post)">
              <!-- Shared-with fleet avatar → fleet image → fleet initials -->
              <img *ngIf="getSharedWithImage(post)" [src]="getSharedWithImage(post)" class="avatar clickable"
                (click)="$event.stopPropagation(); viewGroup(post)"/>
              <div *ngIf="!getSharedWithImage(post)" class="avatar avatar-initials" (click)="$event.stopPropagation(); viewGroup(post)">
                {{ getInitials(formatDisplayName(getSharedWithName(post))) }}
              </div>
              <div class="header-text">
                <div class="shared-top-row">
                  <span class="user-name" >{{ formatDisplayName(getSharedWithName(post)) }}</span>
                </div>
                <span class="author-time-line">
                  <span class="author-name"   (click)="onPostAvatarClick(post, $event)" (error)="onImageError($event)">{{ getWatchHeaderName(post) }}</span>
                  <ng-container *ngIf="(post.audit_data?.create_ts | relativeTime) as relTime">
                    <span class="sep">&bull;</span>
                    <span class="relative-time">{{ relTime }}</span>
                  </ng-container>
                </span>
              </div>
              <!-- Shared Badge — right-aligned -->
              <div class="header-badges">
                <div class="shared-badge">
                   <svg  viewBox="0 0 24 24"
                    fill="none" width="14" height="14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
                    stroke-linejoin="round">
                    <circle cx="9" cy="9" r="2.5"></circle>
                    <circle cx="16.5" cy="8" r="2"></circle>
                    <path d="M5.5 18.5c.6-2.4 2.4-3.8 5-3.8s4.4 1.4 5 3.8"></path>
                    <path d="M15 15.2c1.7.1 2.9 1.1 3.5 3.3"></path>
                  </svg>
                  <span>Shared</span>
                </div>
                <ng-container *ngTemplateOutlet="tripStatePill; context: { $implicit: post }"></ng-container>
              </div>
            </div>

            <div class="divider" *ngIf="!isTextPost(post) && isSharedCommunityPost(post)"></div>

            <!-- HEADER: Standard header (Fallback/Default) -->
            <div class="card-header" *ngIf="
                !isTextPost(post) &&
                (post.post_type === 'trips' || post.post_type === 'waypoint' || isPhotoPost(post)) &&
                !isSharedCommunityPost(post)
              ">
              <img *ngIf="!isAlertWaypointPost(post) && post.source_profile?.image_url"
                [src]="post.source_profile?.image_url" class="avatar clickable"
                (click)="onPostAvatarClick(post, $event)" (error)="onImageError($event)" />
              <div (click)="onPostAvatarClick(post, $event)" *ngIf="isAlertWaypointPost(post) || !post.source_profile?.image_url" class="avatar avatar-initials clickable">
                {{ getInitials(post.post_type === 'trips' ? post.source_profile?.name : getWatchHeaderName(post)) }}
              </div>
              <div class="header-text">
                <span class="shared-with-line" *ngIf="getSharedWithName(post) as sharedWith">Shared with <span
                    class="shared-with-name">{{ sharedWith }}</span></span>
                <div class="shared-top-row">
                  <span class="user-name clickable" (click)="onPostAvatarClick(post, $event)">{{ post.post_type === 'trips' ? post.source_profile?.name : getWatchHeaderName(post) }}</span>
                </div>
                <span class="relative-time">{{ post.audit_data?.create_ts | relativeTime }}</span>
                <div class="ra-watch-participants" *ngIf="isRideAlongTripPost(post)"
                  (click)="openRideAlongParticipants(post, $event)">
                  <div class="ra-avatars" *ngIf="getWatchParticipantAvatars(post).length">
                    <div class="ra-avatar" *ngFor="let a of getWatchParticipantAvatars(post) | slice:0:4">
                      <img *ngIf="a.imageUrl" [src]="a.imageUrl" (error)="a.imageUrl = ''" alt="" />
                      <span *ngIf="!a.imageUrl">{{ a.initials }}</span>
                    </div>
                  </div>
                  <span>Participants</span>
                  <span class="ra-chev">›</span>
                </div>
              </div>
              <!-- Privacy + trip status, side by side. The status pill used to sit on
                   the trip title row below; it reads as detached from the privacy
                   badge there, so both badges now share this one right-aligned group
                   (bug 579). -->
              <div class="header-badges">
                <div class="privacy-badge" [ngClass]="getBadgeType(post)">
                  <svg *ngIf="getBadgeType(post) === 'public'" viewBox="0 0 24 24" fill="none" width="14" height="14"
                    stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="9"></circle>
                    <path d="M3.6 9h16.8"></path>
                    <path d="M3.6 15h16.8"></path>
                    <path d="M12 3c2.2 2.3 3.4 5.5 3.4 9S14.2 18.7 12 21"></path>
                    <path d="M12 3c-2.2 2.3-3.4 5.5-3.4 9s1.2 6.7 3.4 9"></path>
                  </svg>
                  <svg *ngIf="getBadgeType(post) === 'private'" viewBox="0 0 24 24" fill="none" width="14" height="14"
                    stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="5" y="10" width="14" height="10" rx="2"></rect>
                    <path d="M8 10V7.8C8 5.7 9.8 4 12 4s4 1.7 4 3.8V10"></path>
                    <circle cx="12" cy="15" r="1.2" fill="currentColor" stroke="none"></circle>
                  </svg>
                  <svg *ngIf="getBadgeType(post) === 'custom' || getBadgeType(post) === 'shared'" viewBox="0 0 24 24"
                    fill="none" width="14" height="14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
                    stroke-linejoin="round">
                    <circle cx="9" cy="9" r="2.5"></circle>
                    <circle cx="16.5" cy="8" r="2"></circle>
                    <path d="M5.5 18.5c.6-2.4 2.4-3.8 5-3.8s4.4 1.4 5 3.8"></path>
                    <path d="M15 15.2c1.7.1 2.9 1.1 3.5 3.3"></path>
                  </svg>
                  <span>{{ getBadgeLabel(post) }}</span>
                </div>
                <ng-container *ngTemplateOutlet="tripStatePill; context: { $implicit: post }"></ng-container>
              </div>
            </div>

             <div class="divider" *ngIf="
                !isTextPost(post) &&
                (post.post_type === 'trips' || post.post_type === 'waypoint' || isPhotoPost(post)) &&
                !isSharedCommunityPost(post)
              "></div>

            <div class="card-body" *ngIf="!isTextPost(post)">
              <!-- MAIN CONTENT -->
              <!-- TRIP TYPE -->
              <ng-container *ngIf="post.post_type === 'trips'">
                <div class="trip-card-layout">
                  <!-- LEFT: all content -->
                  <div class="trip-content">
                    <div class="trip-headline-row">
                      <span class="headline" (click)="$event.stopPropagation(); openTripDetails(post, true)">{{ post.trip_details?.name || post.content?.headline || "New Trip" }}</span>
                    </div>
                    <div class="description-wrapper"
                      *ngIf="(post.trip_details?.description || post.content?.text)?.trim()">
                      <p class="description">{{ post.trip_details?.description || post.content?.text }}</p>
                      <span class="desc-tooltip"
                        *ngIf="getDescriptionTooltip(post.trip_details?.description || post.content?.text)">{{
                        post.trip_details?.description || post.content?.text }}</span>
                    </div>

                    <!-- Duration / Distance / Dates -->
                    <div class="trip-stats-bar">
                      <div class="tsb-col">
                        <span class="tsb-label"><img src="assets/common_icons/watch_duration.svg" class="tsb-icon" />
                          Duration</span>
                        <span class="tsb-val">{{ calculateDuration(post.trip_details?.start_time,
                          post.trip_details?.end_time, post.trip_details?.trip_state,
                          post.trip_details?.metrics?.duration_hours) }}</span>
                      </div>
                      <div class="tsb-col">
                        <span class="tsb-label"><img src="assets/common_icons/watch_distance.svg" class="tsb-icon" />
                          Distance</span>
                        <span class="tsb-val">{{ getDistance(post.trip_details?.distance ||
                          post.trip_details?.metrics?.distance_covered) }}</span>
                      </div>
                      <div class="tsb-col">
                        <span class="tsb-label"><img src="assets/common_icons/watch_dates.svg" class="tsb-icon" />
                          Date</span>
                        <span class="tsb-val">{{ formatDateRange(post.trip_details?.start_time) }}</span>
                      </div>
                    </div>

                    <!-- Waypoints bar -->
                    <div class="waypoints-summary-bar">
                      <span class="wp-text">
                        Waypoints:
                        <ng-container
                          *ngIf="!isTripWaypointCountLoading(post.trip_details); else watchTripWaypointCountLoading">
                          {{ getTripWaypointCount(post.trip_details) }}
                        </ng-container>
                      </span>
                      <ng-template #watchTripWaypointCountLoading>
                        <span class="wp-count-loader" aria-label="Loading waypoint count"></span>
                      </ng-template>
                      <div class="wp-icons">
                        <div class="w-icon bg-cyan"><img src="assets/common_icons/waypoint_pin_white.svg" width="14"
                            height="14" /></div>
                        <div class="w-icon bg-orange"><img src="assets/common_icons/waypoint_marker_circle.svg"
                            width="14" height="14" /></div>
                        <div class="w-icon bg-purple"><img src="assets/common_icons/waypoint_anchor.svg" width="14"
                            height="14" /></div>
                      </div>
                    </div>

                    <!-- Conditions section — always shown for all trip cards -->
                    <div class="conditions-section">
                      <!-- Always visible: Air Temp | Air Pressure | Moon Illum. -->
                      <div class="conditions-row-3">
                        <div class="cond-card">
                          <span class="cond-val">{{ getAirTempF(post.trip_details?.observation_summary?.air_temp_f)
                            }}</span>
                          <span class="cond-label">Air Temp</span>
                        </div>
                        <div class="cond-card">
                          <span class="cond-val">{{ post.trip_details?.observation_summary?.air_pressure_inhg != null ?
                            (post.trip_details.observation_summary.air_pressure_inhg | number:'1.0-0') + ' inHg' : '--'
                            }}</span>
                          <span class="cond-label">Air Pressure</span>
                        </div>
                        <div class="cond-card">
                          <span class="cond-val">{{
                            getMoonIllumDisplay(post.trip_details?.observation_summary?.moon_illum_fraction) }}</span>
                          <span class="cond-label">Moon Illum.</span>
                        </div>
                      </div>
                      <!-- Expanded: Sunrise | Sunset | Moon Phase (DT suffix stripped) -->
                      <div class="conditions-row-3" *ngIf="isTripPostExpanded(post.id || post._id)">
                        <div class="cond-card">
                          <span class="cond-val">{{
                            cleanTimeValue(post.trip_details?.observation_summary?.sunrise_local) }}</span>
                          <span class="cond-label">Sunrise</span>
                        </div>
                        <div class="cond-card">
                          <span class="cond-val">{{ cleanTimeValue(post.trip_details?.observation_summary?.sunset_local)
                            }}</span>
                          <span class="cond-label">Sunset</span>
                        </div>
                        <div class="cond-card">
                          <span class="cond-val">{{ post.trip_details?.observation_summary?.moon_phase || '--' }}</span>
                          <span class="cond-label">Moon Phase</span>
                        </div>
                      </div>
                      <!-- Vessel name tag (matches fleet detail / trips card) -->
                      <div class="vessel-row"
                        *ngIf="isTripPostExpanded(post.id || post._id) && (post.trip_details?.vessel_name || post.trip_details?.vessel_ref?.name || post.trip_details?.vessel_ref?.identifier)">
                        <img src="assets/home/profile/boaticon.svg" width="14" height="14"
                          style="opacity: 0.5; flex-shrink: 0" />
                        <span>{{ post.trip_details?.vessel_name || post.trip_details?.vessel_ref?.name || post.trip_details?.vessel_ref?.identifier }}</span>
                      </div>
                      <!-- Show more / Show less -->
                      <button class="show-more-btn" (click)="toggleTripPostExpanded(post.id || post._id, $event)">
                        {{ isTripPostExpanded(post.id || post._id) ? 'Show less' : 'Show more' }}
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                          <polyline *ngIf="isTripPostExpanded(post.id || post._id)" points="18 15 12 9 6 15"></polyline>
                          <polyline *ngIf="!isTripPostExpanded(post.id || post._id)" points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </button>
                    </div>

                  </div>

                  <!-- RIGHT: map (position absolute fills grid area) -->
                  <div class="trip-map-container" (click)="onTripMapClick(post, $event)" style="cursor: pointer;">
                    <img [src]="getTripMapUrl(post)" class="static-map" (error)="onImageError($event)" />
                  </div>
                </div>
              </ng-container>



              <!-- PHOTO POST (Matches Mobile _buildPhotoCard) -->
              <ng-container *ngIf="isPhotoPost(post) && !isTextPost(post)">
                <div class="watch-photo-card-body">
                  <!-- Full-bleed photo gallery matching mobile _PhotoStackedPhotoGrid -->
                  <div class="watch-photo-fullbleed-wrap" *ngIf="getPostImages(post) as photoImgs">
                    <!-- 1 image: 4:3 aspect ratio full bleed -->
                    <div
                      class="photo-grid-single"
                      *ngIf="photoImgs.length === 1"
                      (click)="openPhotoLightbox(post, photoImgs[0], $event)"
                    >
                      <img
                        [src]="photoImgs[0]"
                        alt="Photo post"
                        class="full-bleed-photo clickable"
                        loading="lazy"
                        (error)="onImageError($event)"
                      />
                    </div>

                    <!-- 2 images: 16:10 duo equal columns -->
                    <div
                      class="photo-grid-duo"
                      *ngIf="photoImgs.length === 2"
                    >
                      <div
                        class="photo-cell"
                        *ngFor="let img of photoImgs; let idx = index"
                        (click)="openPhotoLightbox(post, img, $event)"
                      >
                        <img
                          [src]="img"
                          alt="Photo post"
                          class="full-bleed-photo clickable"
                          loading="lazy"
                          (error)="onImageError($event)"
                        />
                      </div>
                    </div>

                    <!-- 3+ images: 16:10 lead (flex 3) + stacked (flex 2) -->
                    <div
                      class="photo-grid-stacked"
                      *ngIf="photoImgs.length >= 3"
                    >
                      <div
                        class="photo-cell-lead"
                        (click)="openPhotoLightbox(post, photoImgs[0], $event)"
                      >
                        <img
                          [src]="photoImgs[0]"
                          alt="Photo post"
                          class="full-bleed-photo clickable"
                          loading="lazy"
                          (error)="onImageError($event)"
                        />
                      </div>
                      <div class="photo-cells-stack">
                        <div
                          class="photo-cell-sub"
                          (click)="openPhotoLightbox(post, photoImgs[1], $event)"
                        >
                          <img
                            [src]="photoImgs[1]"
                            alt="Photo post"
                            class="full-bleed-photo clickable"
                            loading="lazy"
                            (error)="onImageError($event)"
                          />
                        </div>
                        <div
                          class="photo-cell-sub"
                          (click)="openPhotoLightbox(post, photoImgs[2], $event)"
                        >
                          <img
                            [src]="photoImgs[2]"
                            alt="Photo post"
                            class="full-bleed-photo clickable"
                            loading="lazy"
                            (error)="onImageError($event)"
                          />
                          <div class="photo-more-badge" *ngIf="photoImgs.length > 3">
                            +{{ photoImgs.length - 3 }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Divider & Interaction Bar below the photo (Instagram order) -->
                  <div class="divider interaction-divider"></div>

                  <app-post-interaction-bar
                    [postId]="getInteractionPostId(post)"
                    [postType]="getInteractionPostType(post)"
                    [initialReactions]="post.reactions"
                    [initialCommentsCount]="getInteractionCommentsCount(post)"
                    [enableShare]="false"
                    [compactCommentsSingleButton]="true"
                  >
                    <button
                      class="action-btn edit-btn"
                      type="button"
                      *ngIf="canEditWatchPost(post)"
                      (click)="$event.stopPropagation(); openWaypointDetails(post)"
                      title="Edit waypoint"
                      aria-label="Edit waypoint"
                    >
                      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                      </svg>
                    </button>
                  </app-post-interaction-bar>

                  <!-- Caption below interaction bar -->
                  <div class="watch-photo-caption" *ngIf="getPostCaption(post)">
                    <p class="caption-text">{{ getPostCaption(post) }}</p>
                  </div>

                  <!-- Muted coordinates footnote (only if valid coords and not N/A) -->
                  <div class="watch-photo-coords" *ngIf="getPhotoCoordinates(post) as coords">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                      <polygon points="3 11 22 2 13 21 11 13 3 11" />
                    </svg>
                    <span>{{ coords }}</span>
                  </div>
                </div>
              </ng-container>

              <!-- WAYPOINT TYPE -->
              <ng-container *ngIf="post.post_type === 'waypoint' && !isTextPost(post) && !isPhotoPost(post)">
                <div class="wp-card-layout">
                  <!-- TOP-LEFT: name, description, coordinates -->
                  <div class="wp-content">
                    <div class="waypoint-headline-row">
                      <div class="wp-type-circle" >
                        <img [src]="getWaypointModelIcon(post)" (click)="$event.stopPropagation(); openWaypointDetails(post)"/>
                      </div>
                      <div class="headline-info" (click)="$event.stopPropagation(); openWaypointDetails(post)">
                        <div class="headline-with-badge">
                          <span class="headline">{{ getWpName(post) }}</span>
                          <span class="fish-qty-badge" *ngIf="getFishQuantityBadge(post) as qty">{{ qty }}</span>
                        </div>
                        <!-- <div class="headline-meta">
                          <span class="headline-time">{{ formatExactTime(post.audit_data?.create_ts) }}</span>
                        </div> -->
                      </div>
                    </div>

                    <div class="description-wrapper" *ngIf="post.waypoint_details?.description">
                      <p class="wp-description">{{ post.waypoint_details.description }}</p>
                      <span class="desc-tooltip" *ngIf="getDescriptionTooltip(post.waypoint_details.description)">{{
                        post.waypoint_details.description }}</span>
                    </div>

                    <div class="location-block">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"
                        style="opacity:0.6;flex-shrink:0">
                        <polygon points="3 11 22 2 13 21 11 13 3 11" />
                      </svg>
                      <span class="coords">{{ getFullCoordinates(post.waypoint_details?.position) }}</span>
                    </div>
                  </div>

                  <!-- RIGHT: media carousel (photos + map) — spans both rows on desktop -->
                  <div class="waypoint-map-container">
                    <ng-container *ngIf="getWpMediaSlides(post) as wpSlides">
                      <div class="wp-slide" *ngFor="let slide of wpSlides; let i = index; trackBy: trackBySlideIndex"
                        [hidden]="i !== getWpSlideIndex(post)">
                        <ng-container *ngIf="slide.type === 'map'; else wpPhotoSlide">
                          <div class="wp-map-slide" (click)="onWpMapClick(post, $event)" style="cursor: pointer;">
                            <img class="static-map" [src]="slide.url" alt="map" (error)="onImageError($event)" />
                            <div class="wp-pin-overlay">
                              <img [src]="getWaypointPinIcon(post)" />
                            </div>
                          </div>
                        </ng-container>
                        <ng-template #wpPhotoSlide>
                          <img class="wp-photo clickable" [src]="slide.url" alt="waypoint photo"
                            (click)="openPhotoLightbox(post, slide.url, $event)" (error)="onImageError($event)" />
                        </ng-template>
                      </div>

                      <!-- Prev / Next arrows -->
                      <button type="button" class="wp-carousel-nav prev" *ngIf="wpSlides.length > 1"
                        aria-label="Previous photo" (click)="wpPrevSlide(post, wpSlides.length, $event)">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                          <polyline points="15 18 9 12 15 6"></polyline>
                        </svg>
                      </button>
                      <button type="button" class="wp-carousel-nav next" *ngIf="wpSlides.length > 1"
                        aria-label="Next photo" (click)="wpNextSlide(post, wpSlides.length, $event)">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                          <polyline points="9 18 15 12 9 6"></polyline>
                        </svg>
                      </button>

                      <!-- Dot indicators -->
                      <div class="wp-carousel-dots" *ngIf="wpSlides.length > 1">
                        <span class="dot" *ngFor="let slide of wpSlides; let i = index; trackBy: trackBySlideIndex"
                          [class.active]="i === getWpSlideIndex(post)" (click)="setWpSlide(post, i, $event)"></span>
                      </div>
                    </ng-container>
                  </div>

                  <!-- BOTTOM-LEFT: show-more (mobile) + stats (desktop always, mobile on expand) -->
                  <div class="wp-bottom-row">
                    <div class="wp-bottom-top-row">
                      <button class="show-more-btn wp-show-more-btn"
                        (click)="toggleWpExpand(post.id || post._id || post.waypoint_details?.waypoint_id || post.waypoint_details?._id); $event.stopPropagation()">
                        {{ expandedWps[post.id || post._id || post.waypoint_details?.waypoint_id ||
                        post.waypoint_details?._id] ? 'Show less' : 'Show more' }}
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                          <polyline
                            *ngIf="expandedWps[post.id || post._id || post.waypoint_details?.waypoint_id || post.waypoint_details?._id]"
                            points="18 15 12 9 6 15"></polyline>
                          <polyline
                            *ngIf="!expandedWps[post.id || post._id || post.waypoint_details?.waypoint_id || post.waypoint_details?._id]"
                            points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </button>
                    </div>

                    <div class="wp-stats-grid"
                      [hidden]="!expandedWps[post.id || post._id || post.waypoint_details?.waypoint_id || post.waypoint_details?._id]">
                      <!-- <div class="wp-stat-cell">
                        <span class="stat-label">Conditions</span>
                        <span class="stat-value">{{ getWpConditions(post.waypoint_details) }}</span>
                      </div> -->
                       <div class="wp-stat-cell">
                        <span class="stat-label">Speed</span>
                        <span class="stat-value">{{ getWpSpeed(post.waypoint_details) }}</span>
                      </div>
                       <div class="wp-stat-cell">
                        <span class="stat-label">Heading</span>
                        <span class="stat-value">{{ getWpHeading(post.waypoint_details) }}</span>
                      </div>
                      <div class="wp-stat-cell">
                        <span class="stat-label">Water temp</span>
                        <span class="stat-value">{{ getWpWaterTemp(post.waypoint_details) }}</span>
                      </div>
                      <div class="wp-stat-cell">
                        <span class="stat-label">Depth</span>
                        <span class="stat-value">{{ getWpWaterDepth(post.waypoint_details) }}</span>
                      </div>
                      <!-- <div class="wp-stat-cell">
                        <span class="stat-label">Wave Height &amp; Period</span>
                        <span class="stat-value">{{ getWpWaveHeightPeriod(post.waypoint_details) }}</span>
                      </div> -->
                      <ng-container *ngIf="hasWpBuoyOrWave(post.waypoint_details)">
                        <div class="wp-stat-cell">
                          <span class="stat-label">Buoy</span>
                          <span class="stat-value">{{ getWpBuoyId(post.waypoint_details) }}</span>
                        </div>
                        <div class="wp-stat-cell">
                          <span class="stat-label">Last Reading</span>
                          <span class="stat-value">{{ getWpLastReading(post.waypoint_details) }}</span>
                        </div>
                      </ng-container>
                      <div class="wp-stat-cell">
                        <span class="stat-label">Air Temp</span>
                        <span class="stat-value">{{ getWpAirTemp(post.waypoint_details) }}</span>
                      </div>
                      <div class="wp-stat-cell">
                        <span class="stat-label">Atm Pressure</span>
                        <span class="stat-value">{{ getWpAirPressure(post.waypoint_details) }}</span>
                      </div>
                    </div>
                  </div>

                </div>
              </ng-container>

              <div class="divider interaction-divider" *ngIf="post.post_type === 'waypoint' && !isPhotoPost(post)"></div>

              <app-post-interaction-bar *ngIf="post.post_type === 'waypoint' && !isPhotoPost(post)" [postId]="getInteractionPostId(post)"
                [postType]="getInteractionPostType(post)" [initialReactions]="post.reactions"
                [initialCommentsCount]="getInteractionCommentsCount(post)" [enableShare]="false"
                [compactCommentsSingleButton]="true">
                <ng-container *ngIf="canEditWatchPost(post)">
                  <button class="action-btn" title="Edit waypoint"
                    (click)="$event.stopPropagation(); openWaypointDetails(post)">
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                    </svg>
                  </button>
                  <button class="action-btn send-btn" title="Send waypoint"
                    (click)="$event.stopPropagation(); openSendTrip(post)">
                    <img src="assets/common_icons/send_trip.svg" width="19" height="14" alt="Send waypoint" />
                  </button>
                  <button class="action-btn" title="Share waypoint" (click)="$event.stopPropagation(); shareTrip(post)">
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round">
                      <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                      <polyline points="16 6 12 2 8 6" />
                      <line x1="12" y1="2" x2="12" y2="15" />
                    </svg>
                  </button>
                </ng-container>

                <ng-container *ngIf="canHidePost(post)">
                  <button class="action-btn hide-from-me-btn" title="Hide from me" aria-label="Hide from me"
                    (click)="$event.stopPropagation(); onHideClick(post, $event)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                      <circle cx="12" cy="12" r="3" />
                      <line x1="1" y1="1" x2="23" y2="23" />
                    </svg>
                  </button>
                </ng-container>
              </app-post-interaction-bar>

              <!-- FLEETS (Invitation/Membership) -->
              <ng-container *ngIf="post.post_type === 'fleets'">
                <div class="simplified-watch-card">
                  <img *ngIf="post.community_ref?.image_url" [src]="post.community_ref?.image_url" class="mini-avatar"
                    (error)="onImageError($event)" (click)="$event.stopPropagation(); viewGroup(post)" />
                  <div *ngIf="!post.community_ref?.image_url" class="mini-avatar mini-avatar-initials" (click)="$event.stopPropagation(); viewGroup(post)">
                    {{ getInitials(post.community_ref?.name) }}
                  </div>
                  <div class="watch-text">
                    <span class="watch-name" (click)="$event.stopPropagation(); viewGroup(post)">{{ post.community_ref?.name }}</span>
                    <p class="watch-desc">{{ post.content?.text }}</p>
                  </div>
                </div>
              </ng-container>

              <!-- WATCH / JOIN REQUEST -->
              <ng-container *ngIf="post.post_type === 'watch'">
                <div class="simplified-watch-card">
                  <img (click)="onPostAvatarClick(post, $event)" (error)="onImageError($event)" *ngIf="post.source_profile?.image_url" [src]="post.source_profile?.image_url" class="mini-avatar"
                    (error)="onImageError($event)" />
                  <div (click)="onPostAvatarClick(post, $event)" (error)="onImageError($event)" *ngIf="!post.source_profile?.image_url" class="mini-avatar mini-avatar-initials">
                    {{ getInitials(post.source_profile?.name) }}
                  </div>
                  <div class="watch-text" (click)="onPostAvatarClick(post, $event)" (error)="onImageError($event)">
                    <span class="watch-name">{{ post.source_profile?.name }}</span>
                    <p class="watch-desc">{{ post.content?.text }}</p>
                  </div>
                </div>
              </ng-container>

              <!-- FRIENDS (Invitation) -->
              <ng-container *ngIf="post.post_type === 'friends'">
                <div class="simplified-watch-card">
                  <img *ngIf="post.source_profile?.image_url" [src]="post.source_profile?.image_url" class="mini-avatar"
                    (error)="onImageError($event)" (click)="onPostAvatarClick(post, $event)" (error)="onImageError($event)" />
                  <div *ngIf="!post.source_profile?.image_url" class="mini-avatar mini-avatar-initials" (click)="onPostAvatarClick(post, $event)" (error)="onImageError($event)">
                    {{ getInitials(post.source_profile?.name) }}
                  </div>
                  <div class="watch-text" (click)="onPostAvatarClick(post, $event)" (error)="onImageError($event)">
                    <span class="watch-name">{{ post.source_profile?.name }}</span>
                    <p class="watch-desc">{{ post.content?.text }}</p>
                  </div>
                </div>
              </ng-container>
            </div>

            <div class="divider interaction-divider" *ngIf="post.post_type === 'trips'"></div>

            <app-post-interaction-bar *ngIf="post.post_type === 'trips'" [postId]="getInteractionPostId(post)"
              [postType]="getInteractionPostType(post)" [initialReactions]="post.reactions"
              [initialCommentsCount]="getInteractionCommentsCount(post)" [enableShare]="false"
              [compactCommentsSingleButton]="true">
              <ng-container *ngIf="!canEditWatchPost(post)">
                <button class="action-btn" title="Open trip"
                  (click)="$event.stopPropagation(); openTripDetails(post, true)">
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <line x1="7" y1="17" x2="17" y2="7" />
                    <polyline points="7 7 17 7 17 17" />
                  </svg>
                </button>
                <button class="action-btn hide-from-me-btn" title="Hide from me" aria-label="Hide from me"
                  (click)="$event.stopPropagation(); onHideClick(post, $event)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                    <circle cx="12" cy="12" r="3" />
                    <line x1="1" y1="1" x2="23" y2="23" />
                  </svg>
                </button>
              </ng-container>

              <ng-container *ngIf="canEditWatchPost(post)">
                <button class="action-btn" title="Edit trip"
                  (click)="$event.stopPropagation(); openTripDetails(post, false)">
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                  </svg>
                </button>
                <button class="action-btn send-btn" title="Send trip"
                  (click)="$event.stopPropagation(); openSendTrip(post)">
                  <img src="assets/common_icons/send_trip.svg" width="19" height="14" alt="Send trip" />
                </button>
                <button class="action-btn" title="Share trip" (click)="$event.stopPropagation(); shareTrip(post)">
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                    <polyline points="16 6 12 2 8 6" />
                    <line x1="12" y1="2" x2="12" y2="15" />
                  </svg>
                </button>
              </ng-container>
            </app-post-interaction-bar>

          </div>
        </ng-container>

        <!-- Pagination Loader -->
        <div class="load-more" *ngIf="loadingMore && feed.length > 0">
          <app-loader [loading]="true" [overlay]="false"></app-loader>
        </div>

        <div *ngIf="!loading && feed.length === 0" class="empty-feed">
          {{ activeFilter ? 'Nothing here yet.' : 'No activity in your feed yet.' }}
        </div>

        <!-- Scroll Sentinel for IntersectionObserver -->
        <div #scrollSentinel class="scroll-sentinel"></div>
      </div>
    </div>
  </div>



  <!-- Send Trip Modal -->
  <div class="bottom-sheet-overlay send-trip-overlay" *ngIf="isSendTripOpen" (click)="closeSendTrip()">
    <div class="bottom-sheet send-trip-sheet" (click)="$event.stopPropagation()">
      <div class="header">
        <div class="drag-handle"></div>
        <div class="header-actions">
          <app-exit-button class="exit-btn-overlay" ariaLabel="Close profile"
            (clicked)="closeSendTrip()"></app-exit-button>
          <!-- <button class="collapse-btn" (click)="closeSendTrip()">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="#1c1c1e" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button> -->
          <h2 class="title">{{ activeSendTrip?.post_type === 'waypoint' ? 'Send Waypoint' : 'Send Trip' }}</h2>
          <button class="save-btn" (click)="confirmSendTrip()">
            <img src="assets/common_icons/blueRight_ticket.svg" />
          </button>
        </div>
      </div>
      <div class="content-scrollable">
        <p class="send-trip-subtitle">{{ activeSendTrip?.post_type === 'waypoint' ? 'Send Waypoint' : 'Send Trip' }} "{{
          activeSendTrip?.post_type === 'waypoint' ? (activeSendTrip?.waypoint_details?.name || activeSendTrip?.name) :
          (activeSendTrip?.trip_details?.name || activeSendTrip?.name) }}" to
          Fleets or Dockmates</p>
        <div class="search-box">
          <img class="search-icon" src="assets/home/profile/searchicon.svg" />
          <input type="text" placeholder="Search fleets or dockmates" [(ngModel)]="sendTripSearchQuery" />
        </div>
        <!-- Fleets -->
        <div class="selection-section" *ngIf="filteredSendFleets.length > 0">
          <label>Fleets</label>
          <div class="item-list">
            <div class="list-item" *ngFor="let fleet of filteredSendFleets"
              [class.already-shared]="fleet.alreadyShared">
              <div class="item-info">
                <div class="checkbox" [class.checked]="fleet.sendSelected || fleet.alreadyShared"
                  [class.disabled]="fleet.alreadyShared"
                  (click)="!fleet.alreadyShared && (fleet.sendSelected = !fleet.sendSelected)"></div>
                <img *ngIf="fleet.logo_url || fleet.image_url || fleet.image"
                  [src]="fleet.logo_url || fleet.image_url || fleet.image" class="avatar"
                  [class.muted]="fleet.alreadyShared" />
                <div *ngIf="!fleet.logo_url && !fleet.image_url && !fleet.image" class="avatar-fallback"
                  [class.muted]="fleet.alreadyShared">
                  {{ getInitials(fleet.name) }}
                </div>
                <div class="info-text">
                  <span class="name" [class.muted-text]="fleet.alreadyShared">{{ fleet.name }}</span>
                  <span class="meta already-shared-label" *ngIf="fleet.alreadyShared">Already shared</span>
                  <span class="meta" *ngIf="!fleet.alreadyShared">{{ fleet.members_count || 0 }} {{ (fleet.members_count
                    || 0) <= 1 ? 'member' : 'members' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Dockmates -->
        <div class="selection-section" *ngIf="filteredSendDockmates.length > 0">
          <label>Dockmates</label>
          <div class="item-list">
            <div class="list-item" *ngFor="let mate of filteredSendDockmates"
              [class.already-shared]="mate.alreadyShared">
              <div class="item-info">
                <div class="checkbox" [class.checked]="mate.sendSelected || mate.alreadyShared"
                  [class.disabled]="mate.alreadyShared"
                  (click)="!mate.alreadyShared && (mate.sendSelected = !mate.sendSelected)"></div>
                <img *ngIf="mate.image_url || mate.image || mate.owner_ref?.image_url || mate.owner_ref?.image"
                  [src]="mate.image_url || mate.image || mate.owner_ref?.image_url || mate.owner_ref?.image"
                  class="avatar" [class.muted]="mate.alreadyShared" />
                <div *ngIf="!mate.image_url && !mate.image && !mate.owner_ref?.image_url && !mate.owner_ref?.image"
                  class="avatar-fallback" [class.muted]="mate.alreadyShared">
                  {{ getInitials(mate.name) }}
                </div>
                <div class="info-text">
                  <span class="name" [class.muted-text]="mate.alreadyShared">{{ mate.name }}</span>
                  <span class="meta already-shared-label" *ngIf="mate.alreadyShared">Already shared</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="filteredSendFleets.length === 0 && filteredSendDockmates.length === 0" class="no-results">
          No fleets or dockmates found.
        </div>
      </div>
    </div>
  </div>

  <!-- Sidebar Area -->
  <div class="sidebar">
    <!-- My Fleets -->
    <div class="sidebar-section">
      <div class="section-header">
        <span class="title">My Fleets</span>
        <button class="see-all" *ngIf="!seeAllFleets" (click)="onSeeAll('fleets')">See all</button>
        <button class="see-all" *ngIf="seeAllFleets" (click)="onSeeLess('fleets')">See less</button>
      </div>
      <div class="section-list">
        <div class="list-item" *ngFor="let fleet of (seeAllFleets ? myFleets : (myFleets | slice:0:3))"
          (click)="onSidebarFleetClick(fleet)">
          <div class="item-avatar" [ngClass]="{'initials': !fleet.logo_url && !fleet.image_url}">
            <img *ngIf="fleet.logo_url || fleet.image_url" [src]="fleet.logo_url || fleet.image_url" />
            <span *ngIf="!fleet.logo_url && !fleet.image_url">{{ getInitials(fleet.name) }}</span>
          </div>
          <div class="item-info">
            <span class="item-name">{{ fleet.name }}</span>
            <span class="item-subtext">{{ fleet.members_count || 0 }} {{ (fleet.members_count || 0) <= 1 ? 'Member'
                : 'Members' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- My Dockmates -->
    <div class="sidebar-section">
      <div class="section-header">
        <span class="title">My Dockmates</span>
        <button class="see-all" *ngIf="!seeAllDockmates" (click)="onSeeAll('dockmates')">See all</button>
        <button class="see-all" *ngIf="seeAllDockmates" (click)="onSeeLess('dockmates')">See less</button>
      </div>
      <div class="section-list">
        <div class="list-item clickable"
          *ngFor="let mate of (seeAllDockmates ? myDockmates : (myDockmates | slice:0:3))"
          (click)="onSidebarDockmatecClick(mate)">
          <div class="item-avatar" [ngClass]="{'initials': !mate.image_url}">
            <img *ngIf="mate.image_url" [src]="mate.image_url" class="item-avatar" />
            <span *ngIf="!mate.image_url">{{ getInitials(mate.name) }}</span>
          </div>
          <div class="item-info">
            <span class="item-name">{{ mate.name }}</span>
            <div class="mutual-connections">
              <div class="avatars-stack" *ngIf="mate.mutual_connections_count > 0">
                <img *ngFor="let img of (mate.mutual_connections_images || []).slice(0, 3)" [src]="img" />
                <div class="more-badge" *ngIf="mate.mutual_connections_count > 3">+{{ mate.mutual_connections_count - 3
                  }}</div>
                <img *ngIf="!(mate.mutual_connections_images || []).length" src="assets/home/profile/user_icon.svg"
                  class="mutual-icon-mini" />
              </div>
              <img *ngIf="mate.mutual_connections_count === 0" src="assets/home/profile/no_mutual_icon.png"
                class="mutual-icon-mini placeholder" />
              <span class="item-subtext">{{ mate.mutual_connections_count }} Mutual {{
                mate.mutual_connections_count === 1 ? 'Connection' : 'Connections' }}</span>
            </div>
            <div class="item-subtext" *ngIf="mate.boat_name && mate.boat_name !== 'No Vessel'">{{ mate.boat_name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Always-present file input so we can trigger it before sheet opens -->
  <input #shareImgInput type="file" accept="image/*" style="display:none" (change)="onShareImageSelected($event)" />

  <!-- Share Image Sheet -->
  <div class="bottom-sheet-overlay share-image-overlay" [style.display]="isShareImageSheetOpen ? 'flex' : 'none'"
    (click)="shareImageStep !== 'generating' && closeShareImageSheet()">
    <div class="bottom-sheet share-image-sheet" (click)="$event.stopPropagation()">
      <div class="header">
        <div class="drag-handle"></div>
        <div class="header-actions">
          <!-- <app-exit-button class="exit-btn-overlay" ariaLabel="Close profile"
            (click)="closeShareImageSheet()"></app-exit-button> -->
          <button class="exit-btn" (click)="shareImageGoBack()" [disabled]="shareImageStep === 'generating'">
             <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L13 13M1 13L13 1" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
          </button>
          <h2 class="title">
            <ng-container *ngIf="shareImageStep === 'choose'">{{ shareImagePost?.post_type === 'waypoint' ? 'Share Waypoint' : 'Share Trip' }}</ng-container>
            <ng-container *ngIf="shareImageStep !== 'choose'">Share Card</ng-container>
          </h2>
          <button class="save-btn si-header-share" *ngIf="shareImageStep === 'generated'" (click)="confirmShareCard()">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
              stroke="#007aff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
              <polyline points="16 6 12 2 8 6" />
              <line x1="12" y1="2" x2="12" y2="15" />
            </svg>
          </button>
          <div *ngIf="shareImageStep !== 'generated'" style="width:32px"></div>
        </div>
      </div>

      <div class="content-scrollable si-content">

        <!-- Step 1: Choose photo -->
        <ng-container *ngIf="shareImageStep === 'choose'">
          <p class="si-trip-name">{{ (shareImagePost?.trip_details?.name || shareImagePost?.waypoint_details?.name) }}</p>
          <label class="si-choose-area">
            <input type="file" accept="image/*" style="display:none" (change)="onShareImageSelected($event)">
            <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 24 24" fill="none"
              stroke="#9ca3af" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <circle cx="8.5" cy="8.5" r="1.5"></circle>
              <polyline points="21 15 16 10 5 21"></polyline>
            </svg>
            <span class="si-choose-label">Choose from Photos</span>
            <span class="si-choose-sub">Tap to select an image from your device</span>
          </label>
        </ng-container>

        <!-- Step 2: Caption + photo preview -->
        <ng-container *ngIf="shareImageStep === 'caption'">
          <p class="si-trip-name">{{ (shareImagePost?.trip_details?.name || shareImagePost?.waypoint_details?.name) }}</p>
          <div class="si-photo-preview">
            <img [src]="shareImagePreviewUrl" class="si-preview-img" />
          </div>
          <button class="si-replace-btn" type="button" (click)="shareImgInput.click()">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
              <circle cx="12" cy="13" r="4"></circle>
            </svg>
            Replace Photo
          </button>
          <div class="si-caption-group">
            <label class="si-label">Write your caption</label>
            <p class="si-caption-subtitle">Appears on the share card image above with the typed caption along with trip main information.</p>
            <textarea class="si-caption" [(ngModel)]="shareImageCaption"
              placeholder="Add a description" rows="4" maxlength="250"></textarea>
            <div class="si-caption-footer">
              <span></span>
              <span class="si-char-count">{{ shareImageCaption.length }}/250</span>
            </div>
            <span class="si-status error" *ngIf="shareImagePreparationError">{{ shareImagePreparationError }}</span>
          </div>
          <button class="si-generate-btn" (click)="generateShareCard()">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
            </svg>
            Generate
          </button>
        </ng-container>

        <!-- Step 3: Generating spinner -->
        <ng-container *ngIf="shareImageStep === 'generating'">
          <div class="si-generating">
            <span class="si-spinner-dark"></span>
            <p class="si-generating-text">Creating your share card…</p>
          </div>
        </ng-container>

        <!-- Step 4: Generated -->
        <ng-container *ngIf="shareImageStep === 'generated'">
          <h3 class="si-generated-heading">Here is your share card 🎉</h3>
          <div class="si-generated-preview">
            <img [src]="shareImageGeneratedPreviewUrl" class="si-generated-img" alt="Share card preview" />
          </div>
          <button class="si-share-btn" (click)="confirmShareCard()">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
              <polyline points="16 6 12 2 8 6" />
              <line x1="12" y1="2" x2="12" y2="15" />
            </svg>
            Share via...
          </button>
          <span class="si-status error" *ngIf="shareImagePreparationError">{{ shareImagePreparationError }}</span>
        </ng-container>

      </div>
    </div>
  </div>
</div>

  <!-- Embedded Trip Detail Overlay (opened from Watch feed) -->
  <app-trips *ngIf="watchTripId" [initialTripId]="watchTripId" [embeddedMode]="true"
    (overlayClosed)="watchTripId = null">
  </app-trips>

  <!-- Embedded Waypoint Detail Overlay (opened from Watch feed) -->
  <app-waypoints *ngIf="watchWaypointId" [initialWaypointId]="watchWaypointId" [directMode]="true"
    [hideWaypointList]="true" (closed)="watchWaypointId = null">
  </app-waypoints>

<app-fleet-detail *ngIf="selectedFleet" [fleet]="selectedFleet" [hideActivity]="false" (close)="closeFleet()">
</app-fleet-detail>

  <!-- Fleet Detail Popup -->
  <ng-container *ngIf="selectedFleet">
    <!-- Loader while fetching fleet data -->
    <div *ngIf="loadingDetail" class="fleet-detail-loader-overlay" (click)="closeFleet()">
      <div class="fleet-detail-loader-sheet" (click)="$event.stopPropagation()">
        <app-loader [loading]="true" [overlay]="false"></app-loader>
      </div>
    </div>
    <!-- Fleet detail renders only once full data is ready -->
    <app-fleet-detail
      *ngIf="selectedFleet && !loadingDetail"
      [fleet]="selectedFleet"
      [hideActivity]="false"
      (close)="closeFleet()">
    </app-fleet-detail>
  </ng-container>

<!-- Expanded photo viewer — feed photos are clickable (openPhotoLightbox). -->
<app-image-lightbox
  *ngIf="lightboxOpen"
  [images]="lightboxImages"
  [index]="lightboxIndex"
  (closed)="closePhotoLightbox()">
</app-image-lightbox>

<!-- Ride Along participants (from a watch trip's Participants row) -->
<app-ride-along-participants
  *ngIf="raParticipantsOpen"
  [tripId]="raParticipantsTripId"
  [participantsInput]="raParticipantsList"
  [tripName]="raParticipantsTripName"
  (close)="closeRideAlongParticipants()">
</app-ride-along-participants>
<!-- Trip status pill ("In Progress" / "Complete").
     Declared once and rendered into whichever .header-badges group the card's
     header uses, so it always sits directly beside the privacy/shared badge —
     the app pairs the two, and splitting them across rows read as detached
     (bug 579). Non-trip posts render nothing. -->
<ng-template #tripStatePill let-post>
  <div class="state-pill" *ngIf="post?.post_type === 'trips'"
    [ngClass]="post.trip_details?.trip_state || 'completed'">
    <svg *ngIf="(post.trip_details?.trip_state || 'completed') === 'completed'" width="12" height="12"
      viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
      stroke-linejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
    <svg *ngIf="post.trip_details?.trip_state === 'in_progress'" width="12" height="12" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
    <span>{{ (post.trip_details?.trip_state || 'completed') === 'completed' ? 'Complete' :
      ((post.trip_details?.trip_state || 'completed').replace('_', ' ') | titlecase) }}</span>
  </div>
</ng-template>
